export default __webpack_public_path__ + "static/media/04n.31a64b62.jpg";